import { render, staticRenderFns } from "./classCoursesLoader.vue?vue&type=template&id=5a6edf56&"
import script from "./classCoursesLoader.vue?vue&type=script&lang=js&"
export * from "./classCoursesLoader.vue?vue&type=script&lang=js&"
import style0 from "./classCoursesLoader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports